const getters = {
  token: state => state.user.token,
}
// getters便捷访问
export default getters